import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button';
import { toast, Toaster } from "sonner"
import { useNavigate } from "react-router-dom"
import Loading from "../../components/Loading"
import api from '../../controller/api'
import { ProductData } from '../../components/Tables';

export default function ProductList() {
    const [product, setProduct] = useState([])
    const [pageLoading, setPageLoading] = useState(false)

    const navigate = useNavigate()

    const fetchProduct = async () => {
        try {
            const { data: res } = await api.get("/product/list")
            if (res?.data) {
                setProduct(res?.data.reverse())
            }
        } catch (error) {
            console.error(error?.response?.data?.message);
            if (error?.response?.data?.message === "jwt expired") {
                localStorage.removeItem("user");
                window.location.reload();
            }
        } finally {
            setPageLoading(false)
        }
    }

    const deleteProduct = async (id) => {
        try {
            setPageLoading(true)
            await api.delete(`/product/delete/${id}`)
            fetchProduct()
            toast.success("Product deleted")
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.message)
        } finally {
            setPageLoading(false)
        }
    }

    const handleStatus = async (id) => {
        try {
            await api.put("/product/ChangeStatus", { id })
            fetchProduct()
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.message)
        }
    }

    useEffect(() => {
        setPageLoading(true)
        fetchProduct()
    }, [])

    if (pageLoading) return <Loading />
    return (
        <div className='table-data'>
            <Toaster richColors position="top-center" />
            <div className='manage'>
                <h2 style={{ display: "flex", justifyContent: "space-between" }}>
                    Product List
                    <Button variant="contained" onClick={() => navigate("/dashboard/add-product")}>Add Product</Button>
                </h2>
                <ProductData product={product} deleteProduct={deleteProduct} handleStatus={handleStatus} />
            </div>
        </div>
    )
}
